<template>
    <div name="radio-button-list" class="wrapper">
        <radio-button 
            v-for="(label, index) in labelList"
            :key="`label_${index}`"
            :label="label"
            :isError="isError"
            :selected="selectedIndex === index ? true : false"
            @select="select(index)"
        />
    </div>
</template>

<script>
import RadioButton from '@/components/atoms/RadioButton';
export default {
    name: 'radioButtonList',
    components: {
        RadioButton
    },
    props: ['selectedIndex', 'labelList', 'isError'],
    methods: {
        select: function(index)
        {
            this.$emit('select', index);
        }
    }
}
</script>

<style scoped>
    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/RadioButtonList.vue